import Alert from '@customink/pigment-react/lib/components/Alert';

export default function MultipleDeliveryOptions({}) {
  return (
    <Alert severity="warning">
      <strong>
        You have selected multiple delivery options for your order.
      </strong>{' '}
      That means different items may show up at different times.
    </Alert>
  );
}
